<ng-container *ngIf="!isPopupsModalOpened">
  <!-- A2 FLOW -->
  <ng-container *ngIf="step === 1 && getSelectedEntityType() === constants.entityPSD2Type.a2">
    <div class="main-container">
      <ng-container [ngTemplateOutlet]="pageTitle"></ng-container>
      <p class="w-full pb-3">{{'terms.psd2-norm.1' | translate}} <strong>{{'terms.psd2-norm.2' |
          translate}}</strong>{{'terms.psd2-norm.3-1' | translate}} <strong>{{'terms.psd2-norm.3-2' |
          translate}}</strong></p>
      <div class="mb-4 w-full pb-3 flex items-center popup-window-advertisement text-small">
        <img class="mr-2" src="assets/icons/advertisement-grey.svg" alt="">
        <p [innerHTML]="'ONLYTITULARACCOUNTS' | translate"></p>
      </div>
      <div class="permissions">
        <ng-container [ngTemplateOutlet]="permissionList"></ng-container>
      </div>
    </div>
    <ng-container [ngTemplateOutlet]="actionButtonsContinue"></ng-container>
  </ng-container>

  <ng-container *ngIf="step === 2 && getSelectedEntityType() === constants.entityPSD2Type.a2"
    [ngTemplateOutlet]="loaderPage"></ng-container>
  <!-- END A2 FLOW -->

  <!-- ERROR -->
  <ng-container *ngIf="step === -1">
    <app-ag-error [noCancelButton]="true" [errorTitle]="'errors.500.title' | translate"
      [errorDescription]="'errors.500.description' | translate" [buttonText]="'errors.500.button' | translate"
      (buttonClick)="exit()"></app-ag-error>
  </ng-container>
  <!-- END ERROR -->
</ng-container>

<app-modal [ngStyle]="{'display': isPopupsModalOpened ? 'block' : 'none'}"
  (clickedClose)="isPopupsModalOpened = false"></app-modal>

<!-- SHARED TEMPLATES -->
<ng-template #pageTitle>
  <h2 class="w-full page-title"><strong>{{'messages.title.1' | translate}}&nbsp;{{'messages.title.2' |
      translate}}</strong></h2>
</ng-template>

<ng-template #permissionList>
  <div class="w-full permission-list">
    <img *ngIf="getSelectedEntityImage()" [src]="getSelectedEntityImage()" alt="">
    <ng-container *ngIf="!getSelectedEntityImage()">
      <img src="assets/banks/bank-icon.svg" alt=""><strong>{{getSelectedEntityName()}}</strong>
    </ng-container>
    <ul>
      <li>{{'messages.permissions.1' | translate}}</li>
      <li>{{'messages.permissions.2' | translate}}</li>
      <li>{{'messages.permissions.3' | translate}}</li>
    </ul>
  </div>
</ng-template>

<ng-template #loaderPage>
  <div class="main-container">
    <div class="flex flex-col justify-center items-center mb-5">
      <app-spinner class="w-full py-4"></app-spinner>
      <h2 class="w-full text-center"><strong>{{'general.waiting-entity' | translate}}</strong></h2>
      <p class="w-full text-center text-small">{{'terms.waiting' | translate}}</p>
    </div>
  </div>
  <ng-container *ngIf="!isWebview" [ngTemplateOutlet]="actionButtonsRetry"></ng-container>
</ng-template>

<ng-template #actionButtonsContinue>
  <div class="flex justify-between">
    <button *ngIf="canGoBack" id="volver" class="btn-back" (click)="router.navigate([constants.url.index])"></button>
    <div class="btnr corporat">
      <button type="button" id="access" class="btn" (click)="incrementStep()">
        {{'general.continue' | translate}}
        <svg class="arrow-icon" width="24px" height="24px" viewBox="0 0 24 24" version="1.1"
          xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Group">
              <rect id="Rectangle" fill-opacity="0.01" fill="#FFFFFF" x="0" y="0" width="24" height="24"></rect>
              <g id="Group-6" transform="translate(3.000000, 4.000000)" stroke-linecap="round" stroke-linejoin="round"
                stroke-width="2" stroke="var(--stroke-color)">
                <path
                  d="M12,4.02884478 L4.59263626,11.7978009 C4.33511187,12.0673997 3.69318751,12.0673997 3.43519146,11.7978009 L-4,4"
                  id="Stroke-133"
                  transform="translate(4.000000, 8.000000) rotate(-270.000000) translate(-4.000000, -8.000000) "></path>
                <line x1="8.84910145" y1="-0.150898551" x2="8.84910145" y2="16.8491014" id="Stroke-135"
                  transform="translate(9.349101, 8.500000) rotate(-270.000000) translate(-9.349101, -8.500000) "></line>
              </g>
            </g>
          </g>
        </svg>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #actionButtonsConnect>
  <div class="flex justify-between">
    <button *ngIf="canGoBack" id="volver" class="btn-back" (click)="router.navigate([constants.url.index])"></button>
    <div class="btnr corporat">
      <button type="button" id="access" class="btn" (click)="incrementStep()">
        {{'general.access' | translate}}
        <svg class="arrow-icon" width="24px" height="24px" viewBox="0 0 24 24" version="1.1"
          xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Group">
              <rect id="Rectangle" fill-opacity="0.01" fill="#FFFFFF" x="0" y="0" width="24" height="24"></rect>
              <g id="Group-6" transform="translate(3.000000, 4.000000)" stroke-linecap="round" stroke-linejoin="round"
                stroke-width="2" stroke="var(--stroke-color)">
                <path
                  d="M12,4.02884478 L4.59263626,11.7978009 C4.33511187,12.0673997 3.69318751,12.0673997 3.43519146,11.7978009 L-4,4"
                  id="Stroke-133"
                  transform="translate(4.000000, 8.000000) rotate(-270.000000) translate(-4.000000, -8.000000) "></path>
                <line x1="8.84910145" y1="-0.150898551" x2="8.84910145" y2="16.8491014" id="Stroke-135"
                  transform="translate(9.349101, 8.500000) rotate(-270.000000) translate(-9.349101, -8.500000) "></line>
              </g>
            </g>
          </g>
        </svg>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #actionButtonsRetry>
  <div class="flex justify-between">
    <button *ngIf="canGoBack" id="volver" class="btn-back" (click)="router.navigate([constants.url.index])"></button>
    <div class="btnr corporat">
      <button type="button" id="retry" class="btn" (click)="aggregationPsd2()"
        [disabled]="!isPopupWindowClosed()">{{'errors.400.button' | translate}}</button>
    </div>
  </div>
</ng-template>
<!-- END SHARED TEMPLATES -->